module.exports = __webpack_public_path__ + "testerstatic/media/icon-back.61f3e03b.svg";